import {
  CreatePaymentLinkRequestDto,
  CreatePaymentLinkResponseDto,
  ValidatePaymentLinkResponseDto,
  GenericResponse,
  paymentClient,
} from 'core';

export const PaymentLinkApi = {
  CREATE: '/payment-link/create',
  STATUS: (token: string) => `/payment-link/status/${token}`,
  VALIDATE: (token: string) => `/payment-link/validate/${token}`,

  async create(requestDto: CreatePaymentLinkRequestDto): Promise<GenericResponse<CreatePaymentLinkResponseDto>> {
    try {
      const response = await paymentClient.post(this.CREATE, requestDto);
      return response.data;
    } catch (e: any) {
      return {
        isSuccess: false,
        errorMessage: e.response?.data?.message ?? e.message,
      } as GenericResponse<any>;
    }
  },

  async status(token: string): Promise<GenericResponse<{ status: number }>> {
    try {
      const response = await paymentClient.get(this.STATUS(token));
      return response.data;
    } catch (e: any) {
      return {
        isSuccess: false,
        errorMessage: e.response?.data?.message ?? e.message,
      } as GenericResponse<any>;
    }
  },

  async validate(token: string): Promise<GenericResponse<ValidatePaymentLinkResponseDto>> {
    try {
      const response = await paymentClient.get(this.VALIDATE(token));
      return response.data;
    } catch (e: any) {
      return {
        isSuccess: false,
        errorMessage: e.response?.data?.message ?? e.message,
      } as GenericResponse<any>;
    }
  },
};
